import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-element-error-text',
  imports: [],
  templateUrl: './element-error-text.html',
  styleUrl: './element-error-text.css',
  standalone: true,
})
export class ElementErrorText {
  validationError = input.required();
}
